module.exports = __webpack_public_path__ + "img/11.77f5573b.svg";